import React, { useContext } from "react";
import { _t, getSystemSettings } from "../../../../../functions/Functions";
import { useTranslation } from "react-i18next";
import { SettingsContext } from "../../../../../contexts/Settings";
import "./stock.css";

const WastageReport = ({
  name,
  documentDate,
  newWastage,
  newRow,
  wastagePrint,
}) => {
  const { t } = useTranslation();
  const { generalSettings } = useContext(SettingsContext);

  if (!newWastage) return null;

  const {
    branch,
    document_identity,
    item,
    qty,
    category,
    type,
    variation,
    remarks,
  } = newWastage;

  // Check if quantity has a valid value
  const hasQty =
    qty !== undefined &&
    qty !== null &&
    qty !== "" &&
    Number(qty) > 0;

  // Reusable print field
  const PrintField = ({ children, fullWidth = false }) => (
    <div
      className={`${
        fullWidth ? "col-12" : "col-6"
      } print-text-stock--bold`}
    >
      {children}
    </div>
  );

  return (
    <div className="d-none">
      <div ref={wastagePrint}>
        <div
          className="fk-print"
          style={{
            margin: "20px",
          }}
        >
          <div className="row">
            <div className="col-12">
              {/* ================= HEADER ================= */}
              <div className="text-center mb-3">
                {/* Logo */}
                <div
                  className="mx-auto mb-2"
                  style={{
                    width: "90px",
                  }}
                >
                  <img
                    src={getSystemSettings(
                      generalSettings,
                      "type_logo"
                    )}
                    style={{
                      width: "100%",
                    }}
                    alt=""
                  />
                </div>

                {/* Branch Name */}
                <div className="xlg-print-text-stock print-text-stock text-capitalize print-text-stock--bold">
                  {branch?.name}
                </div>

                {/* Report Name */}
                <div className="mt-1 xlg-print-text-stock print-text-stock text-capitalize print-text-stock--bold">
                  {name}
                </div>
              </div>

              {/* ================= DOCUMENT INFO ================= */}
              <div className="row mx-0 mt-2 mb-2 print-text-stock text-capitalize">
                <PrintField>
                  Document No: {document_identity}
                </PrintField>

                <PrintField>
                  Document Date: {documentDate?.toDateString()}
                </PrintField>
              </div>

              {/* ================= ITEM / QUANTITY ================= */}
              <div className="row mx-0 my-2 print-text-stock text-capitalize">
                {item ? (
                  <PrintField>
                    Item Name: {item?.name}
                  </PrintField>
                ) : (
                  <div className="col-6" />
                )}

                {hasQty ? (
                  <PrintField>
                    Quantity: {Number(qty || 0).toFixed(2)}
                  </PrintField>
                ) : (
                  <div className="col-6" />
                )}
              </div>

              {/* ================= TYPE / FOOD TYPE ================= */}
              <div className="row mx-0 my-2 print-text-stock text-capitalize">
                {type ? (
                  <PrintField>
                    Type: {type}
                  </PrintField>
                ) : (
                  <div className="col-6" />
                )}

                {category ? (
                  <PrintField>
                    Food Type: {category}
                  </PrintField>
                ) : (
                  <div className="col-6" />
                )}
              </div>

              {/* ================= VARIATION ================= */}
              {variation && (
                <div className="row mx-0 my-2 print-text-stock text-capitalize">
                  <PrintField>
                    Variation: {variation}
                  </PrintField>
                </div>
              )}

              {/* ================= REMARKS ================= */}
              {remarks && (
                <div className="row mx-0 my-2 print-text-stock text-capitalize">
                  <PrintField fullWidth>
                    Remarks: {remarks}
                  </PrintField>
                </div>
              )}

              {/* ================= TABLE ================= */}
              {newRow?.length > 0 && (
                <div className="mt-3">
                  <table className="table table-bordered-sm table-hover">
                    <thead className="align-middle">
                      <tr>
                        <th
                          scope="col"
                          className="print-text-stock text-capitalize align-middle text-center border-dark border-1 border table-Child"
                          style={{
                            minWidth: "180px",
                          }}
                        >
                          {_t(t("Name"))}
                        </th>

                        <th
                          scope="col"
                          className="print-text-stock text-capitalize align-middle text-center border-dark border-1 border"
                        >
                          {_t(t("Qty"))}
                        </th>

                        <th
                          scope="col"
                          className="print-text-stock text-capitalize align-middle text-center border-dark border-1 border"
                        >
                          {_t(t("Unit"))}
                        </th>
                      </tr>
                    </thead>

                    <tbody className="align-middle">
                      {newRow.map((row, index) => (
                        <tr
                          className="align-middle"
                          key={index}
                        >
                          {/* Name */}
                          <td className="print-text-stock text-capitalize border-dark border-1 align-middle text-center">
                            {row?.item_name}
                          </td>

                          {/* Quantity */}
                          <td className="print-text-stock text-capitalize border-dark border-1 align-middle text-center">
                            {parseInt(row?.qty).toFixed(0)}
                          </td>

                          {/* Unit */}
                          <td className="print-text-stock text-capitalize border-dark border-1 align-middle text-center">
                            {row?.unit_name}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WastageReport;